<!-- NEX-1057: Reihenfolge Status/Ausfuehrung/Prioritaet/Autor folgt der
     bestehenden Filter-Ordnung (NEX-444) und weicht bewusst vom Design-Bundle
     ab (dort Prioritaet/Ausfuehrung/Status/Autor). Die Reihenfolge hier ist
     die etablierte Nutzergewohnheit. -->
<app-filter-dropdown
  name="status"
  [value]="statusValue()"
  [placeholder]="'testCases.filter.allStatus' | translate"
  [options]="statusOptions()"
  (valueChange)="onChange('status', $event)"
/>

<app-filter-dropdown
  name="execution"
  [value]="executionValue()"
  [placeholder]="'testCases.filter.allExecutions' | translate"
  [options]="executionOptions()"
  (valueChange)="onChange('execution', $event)"
/>

<app-filter-dropdown
  name="priority"
  [value]="priorityValue()"
  [placeholder]="'testCases.filter.allPriorities' | translate"
  [options]="priorityOptions()"
  (valueChange)="onChange('priority', $event)"
/>

<app-filter-dropdown
  name="author"
  [value]="authorValue()"
  [placeholder]="'testCases.filter.allAuthors' | translate"
  [options]="authorOptions()"
  (valueChange)="onChange('author', $event)"
/>

@if (hasActiveFilters()) {
  <app-reset-filter-button [label]="'testCases.filter.reset' | translate" (resetClick)="resetFilters.emit()" />
}

<app-saved-views-menu
  [views]="savedViews()"
  [activeName]="activeSavedView()"
  [context]="'TEST_CASES'"
  [projectId]="projectId()"
  (viewSelected)="onSavedViewSelected($event)"
  (viewSaved)="onSavedViewSaved($event)"
  (viewDeleted)="onSavedViewDeleted($event)"
  (viewDeleteFailed)="onSavedViewDeleteFailed($event)"
/>
